import { createFileRoute } from '@tanstack/react-router'
import { TrashPage } from '@/components/pages/TrashPage'

export const Route = createFileRoute('/workspace/trash')({
  component: TrashPage,
})
